import { render, staticRenderFns } from "./SkeletonJumbotronCard.vue?vue&type=template&id=c94edee2&"
import script from "./SkeletonJumbotronCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonJumbotronCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports